import { render, staticRenderFns } from "./newcomer.vue?vue&type=template&id=1cdfc31a&scoped=true&"
import script from "./newcomer.vue?vue&type=script&lang=js&"
export * from "./newcomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfc31a",
  null
  
)

export default component.exports